import { z } from 'zod';

export const betaCallValidation = {
  name: z.string().trim().min(3),
  phone: z.string().min(6),
  optin: z.literal(true, { errorMap: () => ({ message: 'Must be checked' }) }),
};
